// extracted by mini-css-extract-plugin
export default {"card":"YcazP","dark":"fq6VK","light":"syb27","white":"wzB3E","header":"jBNKk","label":"edcdN","link":"rzRZJ","icon":"rfjhk","icon-wrapper":"Zr5Oh"};